export const STAKED_GHO_PROTOCOL = {
  serviceKey: 'StakedGhoService',
  name: 'aave',
  product: 'staked gho',
}
export const SAVINGS_GHO_PROTOCOL = {
  serviceKey: 'PausableERC4626Service',
  name: 'aave',
  product: 'savings gho',
}
export const STAKED_AAVE_PROTOCOL = {
  serviceKey: 'StakedAaveService',
  name: 'aave',
  product: 'staked aave',
}
export const ANGLE_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'angle',
}
export const AVANTIS_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'avantis',
}
export const ANKR_PROTOCOL = {
  serviceKey: 'AnkrEthService',
  name: 'ankr',
  product: 'ankr-eth',
}
export const ARCADIA_PROTOCOL = {
  serviceKey: 'ArcadiaService',
  name: 'arcadia',
}
export const COMPOUND_V3_PROTOCOL = {
  serviceKey: 'CompoundV3Service',
  name: 'compound',
  version: 'v3',
  product: 'compound finance',
}
export const CAP_PROTOCOL = {
  serviceKey: 'YearnV3BaseService',
  name: 'cap',
}
export const DOLOMITE_PROTOCOL = {
  serviceKey: 'DolomiteService',
  name: 'dolomite',
}
export const ETHER_FI_ETH_PROTOCOL = {
  serviceKey: 'EtherfiEthService',
  name: 'ether.fi',
  product: 'eth',
}
export const ETHER_FI_WEETH_PROTOCOL = {
  serviceKey: 'EtherfiWeEthService',
  name: 'ether.fi',
  product: 'weeth',
}
export const ETHER_FI_LIQUID_PROTOCOL = {
  serviceKey: 'EtherfiLiquidService',
  name: 'ether.fi',
  product: 'liquid vault',
}
export const VEDA_LIQUID_BORING_PROTOCOL = {
  serviceKey: 'BoringVaultService',
  name: 'veda',
  product: 'liquid boring vault',
  version: 'atomic queue',
}
export const VEDA_LIQUID_BORING_PROTOCOL_WITH_ON_CHAIN_QUEUE = {
  serviceKey: 'BoringOnChainQueueService',
  name: 'veda',
  product: 'liquid boring vault',
  version: 'boring on chain queue',
}
export const EULER_PROTOCOL = {
  serviceKey: 'EulerService',
  name: 'euler',
  version: 'v2',
}
export const EULER_EARN_PROTOCOL = {
  serviceKey: 'EulerEarnService',
  name: 'euler',
  version: 'v2',
  product: 'earn',
}
export const FLUID_PROTOCOL = {
  serviceKey: 'FluidService',
  name: 'fluid',
}
export const FLUID_ETH_PROTOCOL = {
  ...FLUID_PROTOCOL,
  serviceKey: 'ERC4626Service',
  product: 'eth',
}
export const FRAX_LEND_PROTOCOL = {
  serviceKey: 'FraxLendService',
  name: 'frax',
  product: 'frax lend',
}
export const FRAX_ETH_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'frax',
  product: 'frax eth',
}
export const STAKED_FRAX_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'frax',
  product: 'staked frax',
}
export const STAKED_FRXUSD_PROTOCOL = {
  serviceKey: 'NonTransactionalERC4626Service',
  name: 'frax',
  product: 'staked frxusd',
}
export const GEARBOX_PROTOCOL = {
  serviceKey: 'GearboxService',
  name: 'gearbox',
  product: 'passive pools',
}
export const HOP_PROTOCOL = {
  serviceKey: 'HopService',
  name: 'hop',
}
export const INVERSE_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'inverse finance',
  product: 'sdola',
}
export const MAKER_DAO_PROTOCOL = {
  serviceKey: 'MakerDsrService',
  name: 'maker',
}
export const MAPLE_PROTOCOL = {
  serviceKey: 'NonTransactionalERC4626Service',
  name: 'maple',
  product: 'maple-cash',
}
export const MATRIXDOCK_PROTOCOL = {
  serviceKey: 'MatrixdockService',
  name: 'matrixdock',
  product: 'stbt',
}
export const MEV_PROTOCOL = {
  serviceKey: 'NonTransactionalLiquidErc4626Service',
  name: 'mev',
  product: 'meveth',
}
export const MOONWELL_PROTOCOL = {
  serviceKey: 'MoonwellService',
  name: 'moonwell',
}
export const USDM_PROTOCOL = {
  serviceKey: 'MountainUsdmService',
  name: 'mountain',
}
export const NOTIONAL_VARIABLE_PROTOCOL = {
  serviceKey: 'NotionalVariableService',
  name: 'notional',
  product: 'variable rate',
}
export const ONDO_PROTOCOL = {
  serviceKey: 'OndoService',
  name: 'ondo',
  product: 'ousg',
}
export const MIDAS_PROTOCOL = {
  serviceKey: 'MidasService',
  name: 'midas',
}
export const OPEN_EDEN_PROTOCOL = {
  serviceKey: 'OpenEdenService',
  name: 'open eden',
  product: 'tbill',
}
export const OETH_PROTOCOL = {
  serviceKey: 'OethService',
  name: 'origin',
  product: 'oeth',
}
export const OVERNIGHT_PROTOCOL = {
  serviceKey: 'OvernightService',
  name: 'overnight finance',
  product: 'plus vault',
}
export const POOLTOGETHER_PROTOCOL = {
  serviceKey: 'PoolTogetherService',
  name: 'pooltogether',
}
export const REVERT_FINANCE_PROTOCOL = {
  serviceKey: 'RevertFinanceService',
  name: 'revert.finance',
}
export const ROCKET_POOL_PROTOCOL = {
  serviceKey: 'RocketPoolService',
  name: 'rocket pool',
}
export const SEAMLESS_OPTIMIZER_PROTOCOL = {
  serviceKey: 'SeamlessOptimizerService',
  name: 'seamless',
  product: 'integrated liquidity market',
}
export const SEAMLESS_COLLATERAL_VAULT_PROTOCOL = {
  serviceKey: 'SeamlessCollateralVaultService',
  name: 'seamless',
  product: 'collateral vault',
}
export const SILO_V2_PROTOCOL = {
  serviceKey: 'SiloV2Service',
  name: 'silo',
  version: 'v2',
}
export const SDAI_PROTOCOL = {
  serviceKey: 'SDAISparkService',
  name: 'spark',
  product: 'sdai',
}
export const SPARK_USDC_PROTOCOL = {
  serviceKey: 'SUSDCSparkService',
  name: 'spark',
  product: 'susdc',
}
export const SPARK_SAVINGS_V2_PROTOCOL = {
  serviceKey: 'SparkSavingsV2Service',
  name: 'spark',
  product: 'savings',
  version: 'v2',
}
export const COLLATERAL_VAULT_PROTOCOL = {
  serviceKey: 'SparkCollateralService',
  name: 'spark',
  product: 'collateral vault',
}
export const ETHX_PROTOCOL = {
  serviceKey: 'EthxService',
  name: 'ethx',
  product: 'stader',
}
export const STAKEWISE_V2_PROTOCOL = {
  serviceKey: 'StakewiseV2Service',
  name: 'stakewise',
  version: 'v2',
}
export const STAKEWISE_V3_PROTOCOL = {
  serviceKey: 'StakewiseV3Service',
  name: 'stakewise',
  version: 'v3',
}
export const STAKEWISE_V3_GENESIS_PROTOCOL = {
  serviceKey: 'StakewiseV3OGenesisService',
  name: 'stakewise',
  version: 'v3',
  product: 'genesis',
}
export const STAKEWISE_V3_OSETH_PROTOCOL = {
  serviceKey: 'StakewiseV3OsEthService',
  name: 'stakewise',
  version: 'v3',
  product: 'osETH',
}
export const STARGATE_PROTOCOL = {
  serviceKey: 'StargateService',
  name: 'stargate',
}
export const SWELL_PROTOCOL = {
  serviceKey: 'SwellService',
  name: 'swell',
}
export const KELP_PROTOCOL = {
  serviceKey: 'KelpService',
  name: 'kelp',
  product: 'rseth',
}
export const ULTRAYIELD_PROTOCOL = {
  serviceKey: 'UltrayieldService',
  name: 'ultrayield',
}
export const SYRUP_PROTOCOL = {
  serviceKey: 'SyrupService',
  name: 'syrup',
}
export const SUPERFORM_PROTOCOL = {
  serviceKey: 'SuperformService',
  name: 'superform',
}
export const TERM_PROTOCOL = {
  serviceKey: 'YearnV3BaseService',
  name: 'term',
}
export const YETH_PROTOCOL = {
  serviceKey: 'YEthService',
  name: 'yeth',
  product: 'yearn.finance',
}
export const YEARN_V2_PROTOCOL = {
  serviceKey: 'YearnV2Service',
  name: 'yearn',
  version: 'v2',
}
export const YEARN_V3_PROTOCOL = {
  serviceKey: 'YearnV3Service',
  name: 'yearn',
  version: 'v3',
}
export const SKY_PROTOCOL = {
  serviceKey: 'SUSDSSparkService',
  name: 'sky',
  product: 'sky dao',
}
export const SKY_STUSDS_PROTOCOL = {
  serviceKey: 'StUsdsService',
  name: 'sky',
  product: 'stusds',
}
export const SKY_BRIDGED_PROTOCOL = {
  serviceKey: 'SUSDSBridgedService',
  name: 'sky',
  product: 'sky dao base',
}
export const SKY_USDS_FARM_PROTOCOL = {
  serviceKey: 'SkyFarmService',
  name: 'sky',
  product: 'usds farm',
}
export const RESOLV_USR_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'resolv',
  product: 'staked usr',
}
export const RESOLV_RLP_PROTOCOL = {
  serviceKey: 'ResolvRlpService',
  name: 'resolv',
  product: 'rlp',
}
export const LIDO_PROTOCOL = {
  serviceKey: 'LidoService',
  name: 'lido',
}
export const LIDO_WSTETH_PROTOCOL = {
  serviceKey: 'LidoWstEthService',
  name: 'lido',
  product: 'wsteth',
}
export const LISTA_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'lista',
}
export const ETHENA_PROTOCOL = {
  serviceKey: 'EthenaService',
  name: 'ethena',
  product: 'sUSDe',
}
export const COINBASE_ETH_PROTOCOL = {
  serviceKey: 'CoinbaseEthService',
  name: 'coinbase',
  product: 'cbeth',
}
export const BACKED_PROTOCOL = {
  serviceKey: 'BackedService',
  name: 'backed',
  product: 'bib01',
}
export const AGAVE_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: 'agave',
}
export const WILDCAT_PROTOCOL = {
  serviceKey: 'WildcatV2Service',
  name: 'wildcat',
  version: 'V2',
}
export const POLYGON_LIDO_PROTOCOL = {
  serviceKey: 'PolygonLidoService',
  name: 'lido',
  version: 'polygon',
  product: 'lido.fi',
}
export const METAMORPHO_PROTOCOL = {
  serviceKey: 'MetaMorphoService',
  name: 'morpho',
  product: 'metamorpho',
}
export const MORPHO_V2_PROTOCOL = {
  serviceKey: 'MorphoService',
  name: 'morpho',
  version: 'v2',
}
export const MORPHO_MARKET_PROTOCOL = {
  serviceKey: 'MorphoMarketService',
  name: 'morpho',
  product: 'market',
}
export const BEEFY_PROTOCOL = {
  serviceKey: 'BeefyService',
  name: 'beefy',
}
export const CONVEX_PROTOCOL = {
  serviceKey: 'ConvexService',
  name: 'convex',
  product: 'crv booster',
}
export const COMPOUND_V2_PROTOCOL = {
  serviceKey: 'CompoundV2Service',
  name: 'compound',
  version: 'v2',
  product: 'compound finance',
}
export const CENTRIFUGE_PROTOCOL = {
  serviceKey: 'CentrifugeService',
  name: 'centrifuge',
}
export const AJNA_PROTOCOL = {
  serviceKey: 'AjnaService',
  name: 'ajna',
}
export const AAVE_V3_PROTOCOL = {
  serviceKey: 'AaveService',
  name: 'aave',
  version: 'v3',
  product: 'collateral vault',
}
export const AAVE_V4_TOKENIZATION_SPOKE_PROTOCOL = {
  serviceKey: 'AaveV4TokenizationSpokeService',
  name: 'aave',
  version: 'v4',
  product: 'tokenization spoke',
}
export const AAVE_V4_STANDARD_SPOKE_PROTOCOL = {
  serviceKey: 'AaveV4StandardSpokeService',
  name: 'aave',
  version: 'v4',
  product: 'standard spoke',
}
export const AAVE_V3_UMBRELLA_PROTOCOL = {
  serviceKey: 'AaveUmbrellaService',
  name: 'aave',
  version: 'v3',
  product: 'umbrella',
}
export const AAVE_V2_PROTOCOL = {
  serviceKey: 'AaveV2Service',
  name: 'aave',
  version: 'v2',
  product: 'collateral vault',
}
export const LEVEL_PROTOCOL = {
  serviceKey: 'EthenaService',
  name: 'level',
}
export const RESERVOIR_SAVINGS_PROTOCOL = {
  serviceKey: 'ReservoirSavingsService',
  name: 'reservoir',
  product: 'savings',
}
export const LAZY_SUMMER_PROTOCOL = {
  serviceKey: 'LazySummerService',
  name: 'summer.fi',
  product: 'lazy summer',
}
export const HARVEST_FINANCE_PROTOCOL = {
  serviceKey: 'HarvestFinanceService',
  name: 'harvest finance',
}
export const IPOR_FUSION_PROTOCOL = {
  serviceKey: 'IporFusionService',
  name: 'ipor',
  product: 'fusion',
}
export const NASHPOINT_PROTOCOL = {
  serviceKey: 'NashpointService',
  name: 'nashpoint',
}
export const AERA_MULTI_DEPOSITOR_PROTOCOL = {
  serviceKey: 'AeraMultiDepositorService',
  name: 'aera',
  product: 'multi deposit vault',
}
export const VENUS_PROTOCOL = {
  serviceKey: 'VenusService',
  name: 'venus',
}
export const TOKEMAK_PROTOCOL = {
  serviceKey: 'TokemakService',
  name: 'tokemak',
}
export const INFINIFI_PROTOCOL = {
  serviceKey: 'InfinifiService',
  name: 'infinifi',
  product: 'staked usd',
}
export const LIUSD_PROTOCOL = {
  serviceKey: 'LiUsdService',
  name: 'infinifi',
  product: 'fixed term',
}
export const YO_PROTOCOL = {
  serviceKey: 'YoService',
  name: 'yo',
}
export const HYPERLEND_PROTOCOL = {
  serviceKey: 'HyperlendService',
  name: 'hyperlend',
}
export const UPSHIFT_LENDING_POOL_PROTOCOL = {
  serviceKey: 'UpshiftLendingPoolService',
  name: 'upshift finance',
  product: 'lending pool',
}
export const UPSHIFT_TOKENIZED_VAULT_PROTOCOL = {
  serviceKey: 'UpshiftTokenizedVaultService',
  name: 'upshift finance',
  product: 'tokenized vault',
}
export const UPSHIFT_MULTI_ASSET_VAULT_PROTOCOL = {
  serviceKey: 'UpshiftMultiAssetVaultService',
  name: 'upshift finance',
  product: 'multi asset vault',
}
export const FORTY_ACRES_PROTOCOL = {
  serviceKey: 'ERC4626Service',
  name: '40acres',
}
export const TYDRO_PROTOCOL = {
  serviceKey: 'AaveService',
  name: 'tydro',
}
export const LAGOON_PROTOCOL = {
  serviceKey: 'LagoonService',
  name: 'lagoon',
}
export const EXTRAFI_PROTOCOL = {
  serviceKey: 'ExtrafiService',
  name: 'extrafi',
}
export const EXTRAFI_XLEND_PROTOCOL = {
  serviceKey: 'XlendService',
  name: 'extrafi',
  product: 'xlend',
}
export const MELLOW_MULTIVAULT_PROTOCOL = {
  serviceKey: 'MellowMultivaultService',
  name: 'mellow',
  product: 'multivault',
}
export const MELLOW_CORE_PROTOCOL = {
  serviceKey: 'MellowCoreService',
  name: 'mellow',
  product: 'core',
}
export const MELLOW_DVV_PROTOCOL = {
  serviceKey: 'MellowDvvService',
  name: 'mellow',
  product: 'dvv',
}
export const KPK_OIV_PROTOCOL = {
  serviceKey: 'KpkOivService',
  name: 'kpk',
  product: 'oiv',
}
export const AVON_PROTOCOL = {
  serviceKey: 'AvonService',
  name: 'avon',
}
export const CONCRETE_V2_PROTOCOL = {
  serviceKey: 'ConcreteV2Service',
  name: 'concrete',
  version: 'v2',
}
export const OPENCOVER_PROTOCOL = {
  serviceKey: 'OpencoverService',
  name: 'opencover',
}
export const APYX_PROTOCOL = {
  serviceKey: 'ApyxService',
  name: 'apyx',
}
export const EMBER_PROTOCOL = {
  serviceKey: 'EmberService',
  name: 'ember',
}
export const LIQUITY_V2_PROTOCOL = {
  serviceKey: 'PausableERC4626Service',
  name: 'liquity',
  version: 'v2',
}
export const NEXUS_MUTUAL_RWI_VAULT_PROTOCOL = {
  serviceKey: 'NexusMutualRwiVaultService',
  name: 'nexus mutual',
  product: 'rwi vault',
}
export const ACCOUNTABLE_PROTOCOL = {
  serviceKey: 'AccountableService',
  name: 'accountable',
  product: 'yield-app',
}
export const VAULTS_FYI_EXPERIMENTAL_PROTOCOL = {
  serviceKey: 'VaultsFyiExperimentalService',
  name: 'vaults.fyi',
  version: 'experimental',
}

export const FLYING_TULIP_LEND_PROTOCOL = {
  serviceKey: 'FlyingTulipLendService',
  name: 'flying tulip',
  product: 'lend',
}

export const FLYING_TULIP_SFTUSD_PROTOCOL = {
  serviceKey: 'FlyingTulipSftUsdService',
  name: 'flying tulip',
  product: 'sftusd',
}
